<template>
  <div>
    <h2 class="text-neutral-600">Api de conversões</h2>
    <div class="row">
      <div
        v-for="option in options"
        class="col-xl-3 col-lg-4"
        :key="option.title"
      >
        <button
          @click="
            $router.push({
              name: option.route,
              params: { id: $route.params.id }
            })
          "
        >
          <feature-card v-bind="option" color="#0693FF" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const options = [
  {
    icon: "fa-brands fa-facebook-f",
    title: "Api de conversões do Facebook",
    subtitle: "Integre seu produto à API de conversões do Facebook",
    route: "product-facebook-pixel"
  },
  {
    icon: "fa-brands fa-google",
    title: "Api do Google Analytics",
    subtitle: "Integre seu produto à API do Google Analytics",
    route: "product-google-analytics"
  }
];
export default {
  data() {
    return {
      options
    };
  }
};
</script>
